<template>
	<div id="app">
		<page-data>
			<router-view />
		</page-data>
	</div>
</template>

<script>
import router from '../../router/history';
import PageData from '../../components/page-data';
export default {
	components: {
		PageData,
	},
	created() {
		// 用于兼容端上内嵌页面没有bqqcsrf老接口报错问题
		this.setCookie();
	},
	mounted() {
		// todo needhideheader?
		// if (window.QD_ADMIN_COMMON) {
		// 	window.QD_ADMIN_COMMON.init({
		// 		useNewMenu: true,
		// 		header: {
		// 			id: 'header',
		// 		},
		// 		menu: {
		// 			id: 'menu',
		// 			menuClick: (e, v) => {
		// 				console.log('[菜单]', v, router);
		// 				// 匹配到路由使用
		// 				if (router.matcher.match(v.originUrl).matched.length) {
		// 					e.preventDefault();
		// 					this.$router.push(v.originUrl);
		// 				}
		// 			},
		// 		},
		// 		footer: {
		// 			id: 'footer',
		// 		},
		// 	});
		// }
	},
	methods: {
		getPageData() {
			if (router.currentRoute.meta && router.currentRoute.meta.dataUrl) {
				return this.$ajax.get(router.currentRoute.meta.dataUrl).then(res => res.data)
					.catch((err) => {
						console.log(err);
					});
			}
			return false;
		},
		async setCookie() {
            await this.$ajax.gatewayGet('/v1/basic/account/account_web/token').catch(err => {
                console.log(err);
            });
        },
	},
};
</script>
